module.exports = __webpack_public_path__ + "img/teacher_icon.65bb6a05.png";